import { render, staticRenderFns } from "./waveIcon.vue?vue&type=template&id=6c59dba4&"
import script from "./waveIcon.vue?vue&type=script&lang=js&"
export * from "./waveIcon.vue?vue&type=script&lang=js&"
import style0 from "./waveIcon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports